import { FC } from 'react'
import logo from '../../assets/qhack-2026-powered-by-pennylane.png'
import FooterContent from '../../content/footer'
import { ILinkComponentProps } from '../Navbar/Navbar'
import './Footer.css'
import NewsletterForm from './NewsletterForm/NewsletterForm'

const { title, description, social, policies } = FooterContent

const currentYear = new Date().getFullYear()

const socialLinks = [
  {
    href: social.twitterUrl,
    label: 'X',
    icon: 'bxl bx-twitter-x',
    testId: 'social-link-twitter',
  },
  {
    href: social.linkedInUrl,
    label: 'LinkedIn',
    icon: 'bxl bx-linkedin',
    testId: 'social-link-linkedin',
  },
  {
    href: social.youTubeUrl,
    label: 'YouTube',
    icon: 'bxl bx-youtube',
    testId: 'social-link-youtube',
  },
  {
    href: social.gitHubUrl,
    label: 'GitHub',
    icon: 'bxl bx-github',
    testId: 'social-link-github',
  },
  {
    href: social.discordUrl,
    label: 'Discord',
    icon: 'bxl bx-discord-alt',
    testId: 'social-link-discord',
  },
] as const

const Footer = ({
  smallFooter = false,
  LinkComponent,
}: {
  smallFooter?: boolean
  LinkComponent: FC<ILinkComponentProps>
}) => {
  return (
    <div className="Footer DarkBackgroundFooter">
      {smallFooter ? null : (
        <div className="Footer__main">
          <div className="Footer__content">
            <LinkComponent
              href="https://pennylane.ai/"
              addClass="Footer__logoLink"
              aria-label="PennyLane"
              data-testid="footer-logo-link"
            >
              <img
                src={logo}
                className="Footer__logo"
                alt="QHack 2026"
                data-testid="footer-logo"
              />
            </LinkComponent>
            <div className="Footer__body">
              <div className="Footer__copy">
                {title && <h2 className="Footer__title">{title}</h2>}
                {description && (
                  <p className="Footer__description">{description}</p>
                )}
              </div>
              <div className="Footer__aside">
                <NewsletterForm />
                <div className="SocialLinks">
                  {socialLinks.map(({ href, label, icon, testId }) => (
                    <LinkComponent
                      key={testId}
                      href={href}
                      addClass="SocialLink"
                      aria-label={label}
                      data-testid={testId}
                    >
                      <i className={icon}></i>
                    </LinkComponent>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="BottomFooter">
        <div className="BottomFooter__content">
          <span className="BottomFooter__copyright">
            <i className="bx bx-copyright"></i> {currentYear} Xanadu
          </span>
          {policies.map((policy) => (
            <LinkComponent
              href={policy.link}
              addClass="PolicyLink"
              key={policy.name}
              target="_blank"
              rel="noopener noreferrer"
            >
              {policy.name}
            </LinkComponent>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Footer
